import isString from 'lodash-es/isString';
import { clampRange } from '../dom/range';
import { clearBoldInRange, setBoldInRange } from './bold';
import { removeFontFamilyFromRange, setFontFamilyInRange } from './fontFamily';
import { removeFontSizeFromRange, setFontSizeInRange } from './fontSize';
import { removeHighlightColorFromRange, setHighlightColorInRange } from './highlightColor';
import { clearItalicInRange, setItalicInRange } from './italic';
import { clearStrikethroughInRange, setStrikethroughInRange } from './strikethrough';
import { Style } from './style';
import { removeTextColorFromRange, setTextColorInRange } from './textColor';
import { clearUnderlineInRange, setUnderlineInRange } from './underline';

export function applyStyleToRange(container: Node, uncontainedRange: Range, style: Style): Range {
  let range = clampRange(uncontainedRange, container);
  if (!range) {
    return uncontainedRange;
  }

  if (style.isBold === false) {
    range = clearBoldInRange(container, range);
  } else if (style.isBold === true) {
    range = setBoldInRange(container, range);
  }

  if (style.isItalic === false) {
    range = clearItalicInRange(container, range);
  } else if (style.isItalic === true) {
    range = setItalicInRange(container, range);
  }

  if (style.hasUnderline === false) {
    range = clearUnderlineInRange(container, range);
  } else if (style.hasUnderline === true) {
    range = setUnderlineInRange(container, range);
  }

  if (style.hasStrikethrough === false) {
    range = clearStrikethroughInRange(container, range);
  } else if (style.hasStrikethrough === true) {
    range = setStrikethroughInRange(container, range);
  }

  if (style.textColor === '') {
    range = removeTextColorFromRange(container, range);
  } else if (isString(style.textColor)) {
    range = setTextColorInRange(container, range, style.textColor);
  }

  if (style.highlightColor === '') {
    range = removeHighlightColorFromRange(container, range);
  } else if (isString(style.highlightColor)) {
    range = setHighlightColorInRange(container, range, style.highlightColor);
  }

  if (style.fontFamily === '') {
    range = removeFontFamilyFromRange(container, range);
  } else if (isString(style.fontFamily)) {
    range = setFontFamilyInRange(container, range, style.fontFamily);
  }

  if (style.fontSize === '') {
    range = removeFontSizeFromRange(container, range);
  } else if (isString(style.fontSize)) {
    range = setFontSizeInRange(container, range, style.fontSize);
  }

  return range;
}
